import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { fetchTrustpilotSurvey, TrustpilotSurveyResponse } from './useTrustPilotSurvey.request';

export default function useTrustpilotSurvey(
    options?: Omit<UseQueryOptions<TrustpilotSurveyResponse, AxiosError>, 'queryKey'>
) {
    return useQuery({
        queryKey: ['trustpilotSurvey'],
        queryFn: () => fetchTrustpilotSurvey(),
        staleTime: 1000 * 60 * 5, // 5 minutes
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
    });
}
